import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material";
import Layout from "./utils/layout";
import RequireAuth from "./utils/RequireAuth";
import PageNotFound from "./common/PageNotFound";
import Login from "./components/LoginNew";
import Otp  from "./components/LoginNew/Otp";
import Notification from "./components/Notification";
import ModelSearchNew from "./components/ModelSearchNew";
import ModelView from "./components/ModelSearch/ModelView";
import SpareDetails from "./components/ModelSearchNew/SpareDetails";
import SparePhotos from "./components/ModelSearch/SparePhotos";
import ServiceAdvisory from "./components/ServiceAdvisory";
import TechnicalDocument from "./components/TechnicalDocument";
import UsersDetails from "./components/UserOnboarding/index";
import Brand from "./components/MasterDataManagement/Brand";
import { LoadingProvider } from "./common/LoadingContext";
import { NotificationProvider } from "./common/NotificationContext";
import VendorDetails from "./components/MasterDataManagement/Vendor";
import PartTypeDetails from "./components/MasterDataManagement/PartType";
import SpareSearchNew from "./components/SpareSearchNew/index";
import SpareView from "./components/SpareSearch/SpareView";
import ProductCategory from "./components/MasterDataManagement/ProductCategory";
import ProductFamily from "./components/MasterDataManagement/ProductFamily";
import { Box } from "@mui/system";
import ProductBrick from "./components/MasterDataManagement/ProductBrick";
import EditRightsMainFile from "./components/UserOnboarding/EditRights";
import ResetPassword from "./components/ResetPassword";
import ModelsDetail from "./components/SpareSearch/ModelsDetail";
import BulkUpload from "./components/BulkUpload";
import VendorsDetailBySpareId from "./components/SpareSearch/VendorDetail";
import { useEffect } from "react";
import useGlobalState from "./Context";
import AxiosInterceptorsSetup from "./utils/AxiosWithInterceptorsSetup";
import Protected from "./utils/Protected";
import PortalGuide from "./components/PortalGuide/index";
import Depaertment from "./components/UserOnboarding/Depaertment";
import Function from "./components/UserOnboarding/Function";
import Report from "./components/Report";

const APP_THEME = createTheme({
    palette: {
      type: "light",
      primary: {
        main: "#567aac",
      },
      secondary: {
        main: "#d81f06",
      },
      background: {
        default: "#f5f5f5",
        paper: "#ffffff",
        primary: "#003f93",
      },
      text: {
        secondary: "#9e9e9e",
      },
    },
    typography: {
      fontFamily: "Poppins,sans-serif",
      button: {
        ml: 1,
        fontSize: "13px",
      },
      h6: {
        fontSize: "1rem",
      },
      body1: {
        fontSize: 14,
      },
      body2: {
        fontSize: 12,
      },
      caption: {
        fontSize: 10,
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            "&.Mui-disabled": {
              background: "rgba(0, 0, 0, 0.14)",
              color: "rgba(0, 0, 0, 0.45)",
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            "&.Mui-disabled": {
              color: "rgba(0, 0, 0, 0.45)",
            },
          },
        },
      },
    },
});

function App() {
  const [
    {
      auth,
      advisoriesAccessRights,
      technicalDocAccessRights,
      spareAccessRights,
      rollList,
    },
    dispatch,
  ] = useGlobalState();

  useEffect(() => {
    AxiosInterceptorsSetup(dispatch);
  }, []);

  return (
    <ThemeProvider theme={APP_THEME}>
      <BrowserRouter>
        <Box className="App">
          <LoadingProvider>
            <NotificationProvider>
              <Routes>
                <Route>
                {(rollList?.length > 0 && auth?.token )? (
                    <Route
                      path="/login"
                      element={<Navigate to="/notifications" />}
                    />
                  ) : (
                    <Route path="/login" element={<Login />} />
                  )}
                  {/* Public Routes */}
                 
                  <Route path="/login" element={<Login />} />
                   <Route path="/otp" element={<Otp />} />
                  <Route path="/resetPassword" element={<ResetPassword />} />
                </Route>
                {/* Protected Routes */}

                <Route element={<RequireAuth allowedRoles={rollList} />}>
                  <Route path="/" element={<Notification />}></Route>
                  <Route
                    path="notifications"
                    element={<Notification />}></Route>
                  {/* view details access */}
                  <Route
                    path="/spare-details-view/:spareId"
                    element={<SpareDetails />}></Route>
                  <Route
                    path="/service-advisory-view"
                    element={<ServiceAdvisory />}></Route>
                  <Route
                    path="/technical-document-view"
                    element={<TechnicalDocument />}></Route>
                  <Route
                    path="/spare-search/*"
                    element={
                      <Protected
                        isNormalUser={
                          auth?.ldapParam?.userType !== "Main Admin"
                            ? spareAccessRights.read
                            : true
                        }>
                        <SpareSearchNew />
                      </Protected>
                    }></Route>
                  <Route path="portal-guide" element={<PortalGuide />}></Route>
                  <Route
                    path="/model-search/*"
                    element={
                      <Protected isNormalUser={true}>
                        <ModelSearchNew />
                      </Protected>
                    }></Route>
                  <Route
                    path="/model-search/:id/:brand/:modelName"
                    element={
                      <Protected isNormalUser={true}>
                        <ModelView />
                      </Protected>
                    }></Route>
                  <Route
                    path="/spare-details/:spareId"
                    element={
                      <Protected isNormalUser={true}>
                        <SpareDetails />
                      </Protected>
                    }></Route>
                  <Route
                    path="/spare-photos/:id"
                    element={
                      <Protected isNormalUser={true}>
                        <SparePhotos />
                      </Protected>
                    }></Route>
                  <Route
                    path="/spare-view/:id"
                    element={
                      <Protected isNormalUser={true}>
                        <SpareView />
                      </Protected>
                    }></Route>
                  <Route
                    path="/models-detail/:id"
                    element={
                      <Protected isNormalUser={true}>
                        <ModelsDetail />
                      </Protected>
                    }></Route>
                  <Route
                    path="/vendors-detail/:id"
                    element={
                      <Protected isNormalUser={true}>
                        <VendorsDetailBySpareId />
                      </Protected>
                    }></Route>
                  <Route
                    path="/suppliers-detail/:id"
                    element={
                      <Protected isNormalUser={true}>
                        <VendorsDetailBySpareId />
                      </Protected>
                    }></Route>
                  <Route
                    path="/service-advisory"
                    element={
                      <Protected
                        isNormalUser={
                          auth?.ldapParam?.userType !== "Main Admin"
                            ? advisoriesAccessRights.read
                            : true
                        }>
                        <ServiceAdvisory />
                      </Protected>
                    }></Route>
                  <Route
                    path="/bulk-upload"
                    element={
                      <Protected isNormalUser={false} domainUser={true}>
                        <BulkUpload />
                      </Protected>
                    }></Route>
                  <Route
                    path="/report"
                    element={
                      <Protected isNormalUser={false} domainUser={true}>
                        <Report />
                      </Protected>
                    }></Route>
                  <Route
                    path="/technical-document"
                    element={
                      <Protected
                        isNormalUser={
                          auth?.ldapParam?.userType !== "Main Admin"
                            ? technicalDocAccessRights.read
                            : true
                        }>
                        <TechnicalDocument />
                      </Protected>
                    }></Route>
                  <Route path="/Master_Service" element={<Layout />}>
                    <Route
                      path="category-list"
                      element={
                        <Protected isNormalUser={false} domainUser={true}>
                          <ProductCategory />
                        </Protected>
                      }
                    />
                    <Route
                      path="brand-list"
                      element={
                        <Protected isNormalUser={false} domainUser={true}>
                          <Brand />
                        </Protected>
                      }></Route>
                    <Route
                      path="vendor-list"
                      element={
                        <Protected isNormalUser={false} domainUser={true}>
                          <VendorDetails />
                        </Protected>
                      }></Route>
                    <Route
                      path="PartType-list"
                      element={
                        <Protected isNormalUser={false} domainUser={true}>
                          <PartTypeDetails />
                        </Protected>
                      }></Route>
                    <Route
                      path="family-list"
                      element={
                        <Protected isNormalUser={false} domainUser={true}>
                          <ProductFamily />
                        </Protected>
                      }></Route>
                    <Route
                      path="brick-list"
                      element={
                        <Protected isNormalUser={false} domainUser={true}>
                          <ProductBrick />
                        </Protected>
                      }></Route>
                  </Route>
                  <Route path="/user" element={<Layout />}>
                    <Route
                      path="user-list"
                      element={
                        <Protected isNormalUser={false} domainUser={true}>
                          <UsersDetails />
                        </Protected>
                      }
                    />
                    <Route
                      path="accessRights"
                      element={
                        <Protected isNormalUser={false} domainUser={true}>
                          <EditRightsMainFile />
                        </Protected>
                      }></Route>
                    <Route
                      path="departments"
                      element={
                        <Protected isNormalUser={false} domainUser={true}>
                          <Depaertment />
                        </Protected>
                      }></Route>
                    <Route
                      path="function"
                      element={
                        <Protected isNormalUser={false} domainUser={true}>
                          <Function />
                        </Protected>
                      }></Route>
                  </Route>
                  {/* Catch All - Page Not Found */}
                  <Route path="*" element={<PageNotFound />} />
                </Route>
              </Routes>
            </NotificationProvider>
          </LoadingProvider>
        </Box>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
